import { createAsyncThunk } from "@reduxjs/toolkit";

import axiosChargebee from "../utils/chargebee";
import axiosHubspot from "../utils/hubspot";
import axiosTenant from "../utils/tenant";

import {
  notification
} from "../actions";

export const createInstance = createAsyncThunk("createInstance", async (payload, thunkAPI) => {
  try {
    let response = await axiosTenant.post(`/provisioning-instance`, payload);
    if (response && response.data && response.data.success) {
      return response.data
    } else {
      return response.data
    }
  } catch (e) {
    thunkAPI.dispatch(notification({ title: `We are having some issues`, message: `${e.message}`, type: `error` }));
    console.log("Error:", e)
  }
})

export const callbackInstance = createAsyncThunk("callbackInstance", async (payload, thunkAPI) => {
  try {
    let response = await axiosTenant.get(`/get-process-response?callback=1`, {
      customHeader: payload
    });
    if (response && response.data && response.data.success) {
      thunkAPI.dispatch(notification({ title: `Virtual Space Creation`, message: `${response.data.message}`, type: `success` }));
      return response.data
    } else {
      thunkAPI.dispatch(notification({ title: `Virtual Space Creation`, message: `${response.data.message}`, type: `warning` }));
      return response.data
    }
  } catch (e) {
    thunkAPI.dispatch(notification({ title: `We are having some issues`, message: `${e.message}`, type: `error` }));
    console.log("Error:", e)
  }
})

export const checkValidDomain = createAsyncThunk("updateInstance", async (payload, thunkAPI) => {
  try {
    let response = await axiosTenant.get(`/check-domain?domain=${payload}`);
    if (response && response.data && response.data.success) {
      return response.data
    } else {
      console.log("response: ", response.data)
    }
  } catch (e) {
    thunkAPI.dispatch(notification({ title: `We are having some issues`, message: `${e.message}`, type: `error` }));
    console.log("Error:", e)
  }
})